export const gutter = 12
export const primaryBg = "#008178"
export const active = "#e8f030"
